<template>
  <v-form ref="form">
    <v-row class="pb-8">
      <v-col cols="12">
        <p class="primary--text form__title mb-8">
          DADOS DA APÓLICE
        </p>
      </v-col>
      <v-col cols="12" sm="6" class="pr-sm-5">
        <BaseFormAutocomplete
          id-element="takerNamePolicy"
          placeholder="Inserir"
          v-model="form.nome_fantasia"
          :items="listTaker"
          hide-no-data
          item-text="nome_fantasia"
          item-value="nome_fantasia"
          validate-on-blur
          @keyup="searchInput"
          :return-object="true"
          required
          :rules="[requiredInput]"
          label-text="Tomador Matriz/Filial"
          template-taker
        />
      </v-col>
      <v-col cols="12" sm="6">
        <BaseFormInput
          id-element="economicGroupPolicy"
          placeholder="Inserir"
          v-model="form.tomador.grupo.nome"
          validate-on-blur
          label-text="Grupo Econômico"
          disabled
        />
      </v-col>
      <v-col cols="12" sm="6" class="pr-sm-5">
        <BaseFormInput
          id-element="numberPolicy"
          placeholder="Inserir"
          v-model="form.numero"
          required
          :rules="[requiredInput]"
          validate-on-blur
          label-text="N° Apólice"
        />
      </v-col>
      <v-col cols="12" sm="6">
        <BaseFormSelect
          id-element="situationPolicy"
          placeholder="Selecione"
          v-model="form.situacao"
          :items="listSituation"
          required
          :rules="[requiredInput]"
          label-text="Situação"
          item-text="nome"
          item-value="id"
          :return-object="true"
        />
      </v-col>
      <!-- Essa tela vai mudar, por enquanto esses campos não são mais necessários -->
      <!-- <v-col cols="12" sm="6" class="pr-sm-5" v-if="cancelPolicy">
        <BaseFormInput
          id-element="dateEndTermPolicy"
          placeholder="DD/MM/YYYY"
          v-model="form.cancelada_em"
          required
          :rules="[requiredInput, dateTermValid]"
          label-text="Data do Cancelamento"
          v-facade="maskDate"
        />
      </v-col>
      <v-col cols="12" sm="6" v-if="cancelPolicy">
        <BaseFormSelect
          id-element="reasonCancelPolicy"
          placeholder="Inserir"
          v-model="form.motivo_cancelamento"
          :items="cancelItems"
          item-text="descricao"
          item-value="id"
          :return-object="true"
          required
          :rules="[requiredInput]"
          label-text="Motivo do Cancelamento"
        />
      </v-col>
      <v-col cols="12" class="mb-5" v-if="cancelPolicy">
        <BaseFormTextArea
          id-element="reasonCancelEndorsement"
          placeholder="Inserir"
          v-model="form.justificativa_cancelamento"
          :rules="[requiredInput, maxLengthTextArea]"
          label-text="Justificativa Cancelamento"
        />
      </v-col>
      <v-col cols="12" sm="6" class="pr-sm-5" v-if="downPolicy">
        <BaseFormInput
          id-element="dateDownPolicy"
          placeholder="DD/MM/YYYY"
          v-model="form.baixada_em"
          required
          :rules="[requiredInput, dateTermValid]"
          label-text="Data da Baixa"
          v-facade="maskDate"
        />
      </v-col>
      <v-col cols="12" sm="6" v-if="downPolicy">
        <BaseFormSelect
          id-element="reasonDownPolicy"
          placeholder="Inserir"
          v-model="form.motivo_baixa"
          :items="cancelItems"
          item-text="descricao"
          item-value="id"
          :return-object="true"
          required
          :rules="[requiredInput]"
          label-text="Motivo da Baixa"
        />
      </v-col> -->
      <v-col cols="12" sm="6" class="pr-sm-5">
        <BaseFormSelect
          id-element="typeEmissionPolicy"
          placeholder="Inserir"
          v-model="form.tipo_emissao"
          :items="listEmission"
          required
          :rules="[requiredInput]"
          label-text="Tipo de Emissão"
          item-text="nome"
          item-value="id"
          :return-object="true"
        />
      </v-col>
      <v-col cols="12" sm="6" v-if="renovationPolicy">
        <BaseFormInput
          id-element="previousNumberPolicy"
          placeholder="Inserir"
          v-model="form.numero_anterior"
          required
          :rules="[requiredInput]"
          validate-on-blur
          label-text="N° Apólice Anterior"
        />
      </v-col>
      <v-col cols="12" sm="6" v-if="isEdit">
        <BaseFormInput
          id-element="originPolicy"
          placeholder="Inserir"
          v-model="form.origem_cadastro.nome"
          disabled
          label-text="Origem Cadastro"
        />
      </v-col>
      <v-col cols="12">
        <v-divider />
      </v-col>
    </v-row>
    <v-row class="pb-8 justify-start">
      <v-col cols="12">
        <p class="primary--text form__title mb-5">
          SEGURADORA/PRODUTO
        </p>
      </v-col>
      <v-col cols="12" sm="4" class="pr-sm-5">
        <BaseFormSelect
          id-element="insurancePolicy"
          placeholder="Inserir"
          v-model="form.seguradora"
          :items="listInsuranceCompany"
          required
          :rules="[requiredInput]"
          label-text="Seguradora"
          item-text="nome"
          item-value="id"
          :return-object="true"
          :disabled="isEdit"
        />
      </v-col>
      <v-col cols="12" sm="4" class="pr-sm-5" v-if="hasSelectedSubModality">
        <BaseFormInput
          id-element="subModalityPolicy"
          placeholder="Inserir"
          v-model="form.submodalidade.nome"
          label-text="Sub Modalidade"
          disabled
        />
      </v-col>
      <v-col
        cols="12"
        sm="6"
        md="3"
        class="pb-5 pb-sm-0 pt-sm-8"
        v-if="!isEdit"
      >
        <BaseButton
          class="secondary white--text justify-center"
          width="100%"
          @click="changeViewToModality"
          :disabled="!hasInsurance"
        >
          <fragment v-if="!hasSelectedSubModality">
            <v-icon class="pr-1">
              fa-plus
            </v-icon>
            <span :style="{ flex: 'auto' }">
              INCLUIR MODALIDADE
            </span>
          </fragment>
          <fragment v-else>
            <span :style="{ flex: 'auto' }">
              ALTERAR MODALIDADE
            </span>
          </fragment>
        </BaseButton>
        <div
          v-if="errorMessagesModality.length > 0"
          class="v-text-field__details mt-4"
        >
          <div class="v-messages theme--light error--text" role="alert">
            <div class="v-messages__wrapper">
              <div
                v-for="(message, index) in errorMessagesModality"
                :key="`error-message-${index}`"
                class="v-messages__message"
              >
                {{ message }}
              </div>
            </div>
          </div>
        </div>
      </v-col>
      <v-col cols="12">
        <v-divider />
      </v-col>
    </v-row>
    <v-row class="pb-8">
      <v-col cols="12" sm="6" md="9">
        <v-row>
          <v-col cols="auto" class="pr-3">
            <p class="primary--text form__title">
              COSSEGURO
            </p>
          </v-col>
          <v-col cols="auto">
            <BaseButton icon @click="showCoInsurance()">
              <v-icon color="secondary" size="14">
                {{ iconShowCoInsurance }}
              </v-icon>
            </BaseButton>
          </v-col>
        </v-row>
      </v-col>
      <v-col
        cols="12"
        sm="6"
        md="3"
        class="pb-4 pb-sm-0"
        v-if="enableCoInsurance && form.seguradora"
      >
        <BaseButton
          class="secondary white--text justify-center"
          width="100%"
          @click="showModalCoInsurance"
        >
          <v-icon class="pr-1">
            fa-plus
          </v-icon>
          <span :style="{ flex: 'auto' }">
            INCLUIR COSSEGURO
          </span>
        </BaseButton>
      </v-col>
      <v-col cols="12" v-if="enableCoInsurance" class="pt-4">
        <BaseDataTable
          :headers="header"
          :items="form.cosseguros"
          hide-default-footer
        >
          <template v-slot:[`item.participacao`]="{ item }">
            {{ item.participacao }}%
          </template>
          <template v-slot:[`item.seguradora`]="{ item }">
            <BaseButton
              color="secondary"
              class="px-0"
              @click="deleteItem(item)"
              style="min-width: 40px !important;"
              :disabled="item.seguradora.id === form.seguradora.id"
            >
              <img src="@/assets/ic_trash.svg" alt="Excluir seguradora" />
            </BaseButton>
          </template>
        </BaseDataTable>
      </v-col>
      <v-col cols="12" class="pt-10">
        <v-divider />
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <p class="primary--text form__title mb-5">
          PRAZOS E EMISSÃO
        </p>
      </v-col>
      <v-col cols="12" sm="4" md="3" class="pr-sm-5">
        <BaseFormInput
          id-element="emissionPolicy"
          placeholder="DD/MM/YYYY"
          v-model="form.emitida_em"
          required
          :rules="[requiredInput, dateTermValid]"
          v-facade="maskDate"
          validate-on-blur
          label-text="Emissão"
        />
      </v-col>
      <v-col cols="12" sm="4" md="3" class="pr-sm-5">
        <BaseFormInput
          id-element="startDateTermPolicy"
          placeholder="DD/MM/YYYY"
          v-model="form.inicio_vigencia"
          required
          :rules="[requiredInput, dateTermValid, greaterThanIssueDate]"
          v-facade="maskDate"
          validate-on-blur
          label-text="Início de Vigência"
        />
      </v-col>
      <v-col cols="12" sm="4" md="3">
        <BaseFormInput
          id-element="endDateTermPolicy"
          placeholder="DD/MM/YYYY"
          v-model="form.fim_vigencia"
          required
          :rules="[requiredInput, dateTermValid, greaterThanStartDate]"
          validate-on-blur
          label-text="Término de Vigência"
          v-facade="maskDate"
        />
      </v-col>
    </v-row>
    <v-row class="pb-4">
      <v-col cols="12" sm="6" md="4" class="pb-5 pb-sm-0">
        <div class="policy-form__col py-5 px-4">
          <p class="button primary--text mb-0">
            Prazo de vigência:
          </p>
          <p class="font-weight-bold primary--text mb-0">
            {{ intervalTerm }} DIAS
          </p>
        </div>
      </v-col>
    </v-row>
    <v-row class="pb-4">
      <v-col cols="12" sm="4" md="3">
        <p class="form__label primary--text mb-5">
          Prorrogação de Vigência?
        </p>
        <v-switch
          class="pa-0 ma-0 justify-self-center d-inline-block base-form-switch"
          inset
          dense
          hide-details
          color="secondary"
          v-model="form.prorrogar_vigencia"
        />
        <p class="pl-1 mb-0 d-inline-block darkBluishGray--text body-2">
          {{ extendTerm }}
        </p>
      </v-col>
    </v-row>
    <v-row class="pb-8">
      <v-col cols="12" sm="4" md="3" class="pr-sm-5" v-if="hasExtendDate">
        <BaseFormInput
          id-element="endDateTermPolicy"
          placeholder="DD/MM/YYYY"
          v-model="form.data_prorrogacao"
          required
          :rules="[requiredInput, dateTermValid]"
          v-facade="maskDate"
          validate-on-blur
          label-text="Data de Prorrogação"
        />
      </v-col>
      <v-col cols="12">
        <v-divider />
      </v-col>
    </v-row>
    <v-row class="pb-8">
      <v-col cols="12">
        <p class="primary--text form__title mb-5">
          SEGURADO/OBJETO
        </p>
      </v-col>
      <v-col cols="12" sm="4" class="pr-sm-5">
        <BaseFormSelect
          id-element="typeInsuredPolicy"
          placeholder="Selecionar"
          v-model="form.segurado.tipo_pessoa"
          :items="listType"
          required
          :rules="[requiredInput]"
          label-text="Tipo Segurado"
          item-text="nome"
          item-value="id"
          :return-object="true"
        />
      </v-col>
      <v-col cols="12" sm="4" class="pr-sm-5">
        <BaseFormAutocomplete
          id-element="cpfPolicy"
          placeholder="Inserir"
          v-model="form.segurado.numero_documento"
          :items="listInsured"
          :rules="validTypeDocumentAccordingOptionsQuotation"
          validate-on-blur
          label-text="CPF/CNPJ"
          @keyup="searchInput"
          item-text="numero_documento"
          item-value="numero_documento"
          hide-no-data
          :return-object="true"
          :template-insured="true"
        />
      </v-col>
      <v-col cols="12" sm="8" class="pr-sm-5">
        <BaseFormAutocomplete
          id-element="insuredPolicy"
          placeholder="Inserir"
          v-model="form.segurado.nome"
          :items="listInsured"
          :rules="[requiredInput]"
          validate-on-blur
          label-text="Segurado"
          item-text="nome"
          item-value="nome"
          @keyup="searchInput"
          hide-no-data
          :return-object="true"
          :template-insured="true"
        />
      </v-col>
      <v-col cols="12" sm="3" class="pb-5 pb-sm-0 pt-sm-8">
        <BaseButton
          class="secondary"
          width="100%"
          @click="openModalAddress"
          v-html="'ENDEREÇO'"
        />
      </v-col>
      <v-col cols="12" class="mb-5" v-if="isAdditionalCoverageRequired">
        <v-switch
          v-model="form.cobertura_adicional"
          class="pa-0 ma-0 justify-self-center d-inline-block base-form-switch"
          inset
          dense
          hide-details
          color="secondary"
        />
        <p class="pl-1 mb-0 d-inline-block darkBluishGray--text body-2">
          Há cobertura adicional
          <v-tooltip bottom content-class="tooltip-label-form">
            <template v-slot:activator="{ on }">
              <v-icon color="secondary" size="10" v-on="on">
                fa-info-circle
              </v-icon>
            </template>
            <v-row>
              <v-col cols="12" class="px-4 py-3">
                <p class="white--text tooltip-label-text mb-0">
                  Selecione esta opção caso o contrato objeto do seguro possua
                  coberturas adicionais a serem inseridas no seguro. Por
                  exemplo, cobertura de multas contratuais ou de obrigações
                  trabalhistas e previdenciárias. Descreva abaixo as condições
                  exigidas.
                </p>
              </v-col>
            </v-row>
          </v-tooltip>
        </p>
      </v-col>
      <v-col cols="12" v-if="isContractInfoRequired">
        <BaseFormTextArea
          id-element="infoContractProcessQuotation"
          placeholder="Informe"
          v-model="form.informacoes_contrato"
          required
          :rules="[requiredInput, maxLengthTextArea]"
          label-text="Informações do contrato"
          icon-information
          text-information="Aqui você deve descrever todas as características relevantes do contrato que é objeto do seguro garantia para qual solicita cotação. Informações como valores e prazos são essenciais."
        />
      </v-col>
      <fragment v-if="isJudiciaryProcessNumberRequired">
        <v-col cols="12" sm="4" class="pr-sm-5" v-if="isTypeProcessRequired">
          <BaseFormSelect
            id-element="typeInsuredPolicy"
            placeholder="Selecionar"
            v-model="form.processo.tipo_processo"
            item-text="nome"
            item-value="id"
            :return-object="true"
            :items="listEmissionType"
            required
            :rules="[requiredInput]"
            label-text="Tipo de Processo"
          />
        </v-col>
        <v-col cols="12" sm="8" v-if="isEletronicProcess">
          <BaseFormInput
            id-element="insuredPolicy"
            placeholder="Inserir"
            v-model="form.processo.numero_processo"
            required
            :rules="[requiredInput, numberProcessValid]"
            validate-on-blur
            label-text="N° Processo Judicial"
            v-facade="maskNumberProcess"
          />
        </v-col>
        <v-col cols="12" sm="8" v-else>
          <BaseFormInput
            id-element="insuredPolicy"
            placeholder="Inserir"
            v-model="form.processo.numero_processo"
            required
            :rules="[requiredInput, maxLengthPhysicalProcess]"
            validate-on-blur
            label-text="N° Processo Judicial"
          />
        </v-col>
        <v-col cols="12" sm="6" class="pr-sm-5" v-if="hasSelectableCourt">
          <BaseFormSelect
            id-element="courtPolicy"
            placeholder="Selecionar"
            v-model="form.processo.tribunal"
            :item-text="concatCourtRegion"
            item-value="id"
            :return-object="true"
            :items="listJusticeRegion"
            required
            :rules="[requiredInput]"
            :label-text="nameLabelCourt"
          />
        </v-col>
        <v-col cols="12" sm="6" class="pr-md-5" v-else>
          <BaseFormInput
            id-element="justiceRegionEditQuotation"
            placeholder="Digite"
            v-model="form.processo.tribunal.nome"
            required
            :rules="[requiredInput]"
            :label-text="nameLabelCourt"
          />
        </v-col>
        <v-col cols="12" sm="6" v-if="hasSelectableCourt">
          <BaseFormSelect
            id-element="regionCourtPolicy"
            placeholder="Selecionar"
            v-model="form.processo.unidade"
            item-text="nome"
            item-value="id"
            :return-object="true"
            :items="listCourtJustice"
            required
            :rules="[requiredInput]"
            :label-text="nameLabelJusticeRegion"
          />
        </v-col>
        <v-col cols="12" sm="6" v-else>
          <BaseFormInput
            id-element="courtJusticeEditQuotation"
            placeholder="Digite"
            v-model="form.processo.unidade.nome"
            required
            :rules="[requiredInput]"
            :label-text="nameLabelJusticeRegion"
          />
        </v-col>
      </fragment>
      <v-col cols="12" sm="4" class="pr-sm-5">
        <BaseFormInput
          id-element="numberClientPolicy"
          placeholder="Inserir"
          v-model="form.numero_controle_interno"
          required
          validate-on-blur
          label-text="N° Interno Cliente"
        />
      </v-col>
      <v-col cols="12" sm="4" class="pr-sm-5">
        <BaseFormSelect
          id-element="officeQuotation"
          placeholder="Seleção"
          v-model="form.escritorio"
          :items="listOfficeQuotation"
          item-text="nome_fantasia"
          item-value="id"
          label-text="Escritório Responsável"
          :return-object="true"
          required
          :rules="[requiredInput]"
          :disabled="disabledOffice"
        />
      </v-col>
      <v-col cols="12" sm="4" md="3" class="pb-5 pb-sm-0 pt-sm-8">
        <BaseButton
          class="secondary"
          v-html="'OBJETO DO SEGURO'"
          width="100%"
          @click="openModalInsuranceObject"
        />
      </v-col>
      <v-col cols="12">
        <v-divider />
      </v-col>
    </v-row>
    <PolicyFormSection
      :form="form"
      :error-messages="errorMessagesPolicy"
      is-policy-without-quotation
    />
    <BaseFooter>
      <v-row>
        <v-spacer />
        <v-col cols="12" sm="5" md="3" xl="2" class="pr-sm-5">
          <BaseButton
            v-html="'CANCELAR'"
            class="pink white--text"
            width="100%"
            @click="$emit('cancel')"
          />
        </v-col>
        <v-col cols="12" sm="5" md="3" xl="2">
          <BaseButton
            v-html="nameButton"
            class="secondary"
            width="100%"
            @click="submit"
          />
        </v-col>
      </v-row>
    </BaseFooter>
    <ModalCoInsurance
      v-if="modalCoInsurance"
      v-model="modalCoInsurance"
      @close="closeModal"
      @submit="newCoInsuranceItems"
      :items="form.cosseguros"
      :policy-insurance="form.seguradora"
    />
    <ModalAddressForm
      v-model="modalAddress"
      :form="form.segurado"
      @close="closeModalAddress"
      @submit="closeModalAddress"
      :options-policy="optionsPolicy"
    />
    <ModalInsuranceObject
      v-model="modalInsuranceObject"
      :form="form"
      @close="closeModalInsuranceObject"
      @submit="closeModalInsuranceObject"
    />
  </v-form>
</template>
<script>
import {
  requiredInput,
  dateTermValid,
  isValidCpfOrCnpj,
  numberProcessValid,
  maxLengthPhysicalProcess,
  maxLengthTextArea,
  documentNumberMatchesType
} from "@/utils/rules.js";
import { maskDate, maskNumberProcess } from "@/utils/masks.js";
import PolicyFormSection from "@/components/form/PolicyFormSection";
import ModalCoInsurance from "@/components/ModalCoInsurance";
import ModalAddressForm from "../components/ModalAddressForm";
import ModalInsuranceObject from "../components/ModalInsuranceObject";
import { mapState, mapActions } from "vuex";
import { LoadingRequest } from "@/mixins/LoadingMixin";
import _ from "lodash";
import CompanyMixin from "@/mixins/CompanyMixin";
import OfficeMixin from "@/mixins/OfficeMixin";
import * as BRUtils from "@brazilian-utils/brazilian-utils";
import { intervalDates } from "@/utils/formats.js";
import LabelInputMixin from "@/mixins/LabelInputMixin";
const tableHeaders = [
  { text: "Seguradora", value: "seguradora.nome", sortable: false },
  { text: "Partipação (%)", value: "participacao", sortable: false },
  { text: "Ações", value: "seguradora", sortable: false }
];
const mockEmissionType = [
  {
    nome: "PROCESSO FÍSICO",
    id: "fisico"
  },
  {
    nome: "PROCESSO ELETRÔNICO",
    id: "eletronico"
  }
];
const mockListType = [
  {
    id: "pessoa_fisica",
    nome: "PESSOA FÍSICA"
  },
  {
    id: "pessoa_juridica",
    nome: "PESSOA JURÍDICA"
  }
];
const SEGMENT_ID = "justica_trabalho";
export default {
  data: () => ({
    enableCoInsurance: false,
    listMock: [1, 2, 3],
    requiredInput,
    dateTermValid,
    maskDate,
    modalCoInsurance: false,
    header: tableHeaders,
    errorMessagesBills: [],
    errorMessagesPolicy: [],
    errorMessagesJustify: [],
    modalAddress: false,
    modalInsuranceObject: false,
    timeout: null,
    listEmissionType: mockEmissionType,
    listType: mockListType,
    isValidCpfOrCnpj,
    maskNumberProcess,
    numberProcessValid,
    maxLengthPhysicalProcess,
    maxLengthTextArea,
    intervalDates,
    errorMessagesModality: []
  }),
  components: {
    PolicyFormSection,
    ModalCoInsurance,
    ModalAddressForm,
    ModalInsuranceObject
  },
  mixins: [LoadingRequest, CompanyMixin, OfficeMixin, LabelInputMixin],
  created() {
    Promise.all([
      this.form.seguradora &&
        this.fetchModalityAccordingInsurance(this.form.seguradora.id),
      this.isElectronic ? this.fetchNumberProcess() : this.fetchJusticeRegion(),
      this.form.tomador?.grupo?.id && this.fetchOfficeQuotation()
    ]);
  },
  computed: {
    ...mapState("policy", [
      "listTaker",
      "listSituation",
      "listInsuranceCompany",
      "listEmission",
      "listInsured",
      "cancelItems"
    ]),
    ...mapState("quotation", [
      "listCourtJustice",
      "listJusticeRegion",
      "eletronicProcessValue",
      "listOfficeQuotation"
    ]),
    ...mapState("insuranceCompany", ["currentInsuranceCompany"]),
    iconShowCoInsurance() {
      return this.enableCoInsurance ? "fa-chevron-up" : "fa-chevron-down";
    },
    extendTerm() {
      return this.form.prorrogar_vigencia ? "Sim" : "Não";
    },
    // cancelPolicy() {
    //   return this.form.situacao?.id == "cancelada";
    // },
    // downPolicy() {
    //   return this.form.situacao?.id == "baixada";
    // },
    renovationPolicy() {
      return this.form.tipo_emissao?.id == "renovacao";
    },
    hasInsurance() {
      return (
        this.currentInsuranceCompany && this.currentInsuranceCompany.modalidades
      );
    },
    hasExtendDate() {
      return this.form.prorrogar_vigencia;
    },
    isElectronic() {
      return this.form.processo?.tipo_processo?.id == "eletronico";
    },
    hasSelectedSubModality() {
      return this.form.submodalidade?.nome;
    },
    isEletronicProcess() {
      return this.form.processo?.tipo_processo == "eletronico";
    },
    validTypeDocumentAccordingOptionsQuotation() {
      return this.optionsPolicy?.segurado[this.form.segurado?.tipo_pessoa?.id]
        ?.documento.obrigatorio
        ? [this.requiredInput, this.isValidCpfOrCnpj, this.ruleSameType]
        : [];
    },
    ruleSameType() {
      return documentNumberMatchesType(
        this.form.segurado?.tipo_pessoa?.id,
        this.form.segurado?.numero_documento
      );
    },
    isAdditionalCoverageRequired() {
      return this.optionsPolicy?.cobertura_adicional?.obrigatorio;
    },
    isContractInfoRequired() {
      return this.optionsPolicy?.informacoes_contrato?.obrigatorio;
    },
    isJudiciaryProcessNumberRequired() {
      return this.optionsPolicy?.processo?.numero_processo?.obrigatorio;
    },
    hasSelectableCourt() {
      return !this.optionsPolicy?.processo?.tribunal?.nome_livre;
    },
    intervalTerm() {
      return intervalDates(this.form.inicio_vigencia, this.form.fim_vigencia);
    },
    isTypeProcessRequired() {
      return this.optionsPolicy?.processo_judiciario?.tipo_processo
        ?.obrigatorio;
    },
    isModalityJudicial() {
      return this.form.modalidade?.id === "judicial";
    }
  },
  methods: {
    ...mapActions("policy", [
      "requestListTaker",
      "requestInsuredByNameOrNumber"
    ]),
    ...mapActions("insuranceCompany", ["requestCurrentInsuranceCompany"]),
    ...mapActions("quotation", [
      "requestNumberProcess",
      "requestCourtJustice",
      "requestJusticeRegion"
    ]),
    ...mapActions(["showAlertNotification"]),
    searchInput(value) {
      clearTimeout(this.timeout);
      let vm = this;
      // fazer requisição apenas se tiver valor no input
      if (value.target.value.length >= 3)
        this.timeout = setTimeout(function() {
          const payload =
            value.target.id == "cpfPolicy"
              ? `?query=${value.target.value.replace(/[^0-9]/g, "")} `
              : `?query=${value.target.value}`;
          if (value.target.id == "takerNamePolicy") {
            vm.fetchTaker(payload);
          } else {
            vm.fetchInsured(payload);
          }
          vm.timeout = null;
        }, 500);
    },
    fetchInsured(payload) {
      this.withLoading(this.requestInsuredByNameOrNumber(payload));
    },
    fetchTaker(payload) {
      this.withLoading(this.requestListTaker(payload));
    },
    fetchNumberProcess() {
      this.withLoading(
        this.requestNumberProcess(this.getPayloadNumberProcess())
      );
    },
    getPayloadNumberProcess() {
      return {
        id: SEGMENT_ID,
        number: this.form.processo.numero_processo
      };
    },
    fetchCourtJustice() {
      this.withLoading(
        this.requestCourtJustice(this.getPayloadCourtJustice()).then(() => {
          this.listCourtJustice.length === 1 &&
            (this.form.processo.unidade = this.listCourtJustice[0]);
        })
      );
    },
    getPayloadCourtJustice() {
      return {
        segmentID: SEGMENT_ID,
        justiceID: this.form.processo.tribunal.id
      };
    },
    showCoInsurance() {
      this.enableCoInsurance = !this.enableCoInsurance;
    },
    validate() {
      return (
        this.$refs.form.validate() &&
        this.validateModality() &&
        this.validateInstallments()
      );
    },
    validateModality() {
      this.errorMessagesModality =
        this.form.modalidade?.id && this.form.submodalidade?.id
          ? []
          : ["É selecionar uma modalidade e submodalidade"];
      return Boolean(this.form.modalidade?.id && this.form.submodalidade?.id);
    },
    validateInstallments() {
      // Caso o valor do premio dê diferente das parcelas, ou o valor_premio
      // foi alterado e precisa ser refeito o cálculo do premio ou não foi
      // feito nenhuma vez o cálculo do prêmio e precisa ser feito
      const validate =
        _.round(this.form.valor_premio, 1) ===
        _.round(_.sumBy(this.form.parcelas, "valor"), 1);
      if (!validate) {
        this.showAlertNotification({
          message:
            "É preciso calcular/recalcular o prêmio antes de finalizar processo.",
          type: "error"
        });
      }
      return validate;
    },
    validatePolicy() {
      this.errorMessagesPolicy =
        this.form.apolice.length == 0 ? ["É preciso anexar a apólice"] : [];
      return this.form.apolice.length > 0;
    },
    validateBills() {
      this.errorMessagesBills =
        this.form.boleto.length == 0 ? ["É preciso anexar o boleto"] : [];
      return this.form.boleto.length > 0;
    },
    submit() {
      if (!this.validate()) return;
      this.$emit("submit", this.form);
    },
    showModalCoInsurance() {
      this.modalCoInsurance = true;
    },
    newCoInsuranceItems(item) {
      this.closeModal();
      this.form.cosseguros = item;
    },
    closeModal() {
      this.modalCoInsurance = false;
    },
    closeModalAddress() {
      this.modalAddress = false;
    },
    openModalAddress() {
      this.modalAddress = true;
    },
    closeModalInsuranceObject() {
      this.modalInsuranceObject = false;
    },
    openModalInsuranceObject() {
      this.modalInsuranceObject = true;
    },
    changeViewToModality() {
      this.$emit("modality");
    },
    fetchModalityAccordingInsurance(payload) {
      this.withLoading(this.requestCurrentInsuranceCompany(payload));
    },
    autocompleteFormAccordingInput(value, input) {
      // Se selecionar um elemento do back-end, deve-se autocompletar
      // a tabela inteira conforme o elemente selecionado
      const newValue =
        input == "numero_documento" ? value.replace(/[^0-9]/g, "") : value;
      const item = this.listInsured.find(x => x[input] == newValue);
      if (item) {
        const newForm = _.pick(item, ["tipo_pessoa", "endereco", "nome", "id"]);
        this.form.segurado.numero_documento = !BRUtils.isValidCNPJ(
          item.numero_documento
        )
          ? BRUtils.formatCPF(item.numero_documento)
          : BRUtils.formatCNPJ(item.numero_documento);
        this.form.segurado = this.mergeProperties(newForm, this.form.segurado);
      }
    },
    fetchJusticeRegion() {
      if (this.isJudiciaryProcessNumberRequired)
        this.withLoading(this.requestJusticeRegion(SEGMENT_ID));
    },
    concatCourtRegion(item) {
      return `${item.nome}${
        item.regiao_atuacao ? " (" + item.regiao_atuacao + ")" : ""
      }`;
    },
    deleteItem(item) {
      const index = this.form.cosseguros.indexOf(item);
      this.form.cosseguros.splice(index, 1);
      this.form.cosseguros.find(
        e => e.seguradora.id === this.form.seguradora.id
      ).participacao += +item.participacao;
    },
    greaterThanStartDate(value) {
      if (!value) return true;
      const endDate = new Date(
        this.form.fim_vigencia
          .split("/")
          .reverse()
          .join("-")
      );
      const startDate = new Date(
        this.form.inicio_vigencia
          .split("/")
          .reverse()
          .join("-")
      );
      return (
        endDate > startDate ||
        "Término da vigência deve ser posterior ao início"
      );
    },
    greaterThanIssueDate(value) {
      if (!value) return true;
      const endDate = new Date(
        this.form.inicio_vigencia
          ?.split("/")
          .reverse()
          .join("-")
      );
      const startDate = new Date(
        this.form.emitida_em
          ?.split("/")
          .reverse()
          .join("-")
      );
      return (
        endDate >= startDate ||
        "Início da vigência deve ser posterior ou igual à emissão"
      );
    }
  },
  props: {
    form: {
      type: Object
    },
    nameButton: {
      type: String,
      default: "CRIAR"
    },
    isEdit: {
      type: Boolean,
      default: false
    },
    optionsPolicy: {
      type: Object
    }
  },
  watch: {
    "form.seguradora.id"(value) {
      if (value) this.fetchModalityAccordingInsurance(value);
    },
    "form.segurado.numero_documento"(newValue, oldValue) {
      if (
        !newValue ||
        newValue == oldValue ||
        newValue?.numero_documento == oldValue?.numero_documento
      )
        return;
      const item = newValue?.id || newValue.replace(/[^0-9]/g, "");
      const type = newValue?.id ? "id" : "numero_documento";
      this.autocompleteFormAccordingInput(item, type);
    },
    "form.segurado.nome"(newValue, oldValue) {
      if (!newValue || newValue == oldValue || newValue == oldValue?.nome)
        return;
      const item = newValue?.id || newValue;
      const type = newValue?.id ? "id" : "nome";
      this.autocompleteFormAccordingInput(item, type);
    },
    "form.processo.tipo_processo"(value) {
      if (value.id == "fisico") this.fetchJusticeRegion();
    },
    "form.processo.numero_processo"(value) {
      value &&
        value.length == 25 &&
        this.form.processo.tipo_processo.id == "eletronico" &&
        this.fetchNumberProcess();
    },
    "form.processo.tribunal.nome": {
      immediate: true,
      handler(value) {
        if (value && this.hasSelectableCourt) this.fetchCourtJustice();
      }
    },
    eletronicProcessValue(value) {
      if (this.form.processo.tipo_processo.id == "eletronico" && this.form.processo.unidade.length < 0) {
        this.form.processo.unidade = value.unidade;
        this.form.processo.tribunal = value.tribunal;
      }
    },
    "form.nome_fantasia"(value) {
      if (value) this.form.tomador = value;
    },
    "form.tomador.grupo.id"(value) {
      if (value) this.fetchOfficeQuotation();
    },
    "form.submodalidade"(value) {
      if (value?.id === "administrativa") {
        // Para submodalidade administrativa, os campos de nome_unidade e nome_tribunal
        // devem vir definidos como padrão por N/A, pois nem sempre existem estes campos
        // pois como o campo é obrigatório e eles não querem tirar ela apenas para
        // esta submodalidade, então cria estes valores default no caso de não ter valor.
        this.form.processo.nome_unidade = !this.form.processo.nome_unidade
          ? "N/A"
          : this.form.processo.nome_unidade;
        this.form.processo.nome_tribunal = !this.form.processo.nome_tribunal
          ? "N/A"
          : this.form.processo.nome_tribunal;
      }
    }
  }
};
</script>
<style lang="sass">
.policy-form__
  &col
    border: 1px solid #D5D5E0
    border-radius: 4px
    background-color: #F0F0F7
</style>
